export const WINDOW_OPTIONS = [8, 12, 26, 52];
export const DEFAULT_WINDOW_WEEKS = 26;

// Lift trend labels are derived from the change figures so noise is not called a decline.
export const DECLINE_90D_PCT = -5;
export const DECLINE_30D_PCT = -3;
export const LOAD_CHANGE_CAP_PCT = 200;
export const TRAINING_DAYS_GUIDELINE = 2;

export const COLORS = {
  accent: '#FF00FF',
  good: '#4CD964',
  caution: '#FFB020',
  neutral: '#9AA4B2',
  card: 'rgba(255,255,255,0.06)',
  border: 'rgba(255,255,255,0.14)',
};

export const TREND_LABELS = {
  rising: 'Trending up',
  steady: 'Holding steady',
  declining: 'Trending down',
  insufficient: 'Not enough data yet',
};

export const CONFIDENCE_LABELS = {
  low: 'Low confidence',
  medium: 'Medium confidence',
  high: 'High confidence',
};

export const MUSCLE_STATUS_LABELS = {
  below: 'Below range',
  in_range: 'In range',
  above: 'Above range',
  none: 'No data yet',
};

export const PUSH_PULL_LABELS = {
  balanced: 'Balanced',
  push_dominant: 'Push-heavy',
  pull_dominant: 'Pull-heavy',
  insufficient: 'Building',
};

export const UPPER_LOWER_LABELS = {
  balanced: 'Balanced',
  upper_dominant: 'Upper-heavy',
  lower_dominant: 'Lower-heavy',
  insufficient: 'Building',
};

export const CONSISTENCY_LABELS = {
  strong: 'Strong',
  ok: 'On track',
  low: 'Below the guideline',
  insufficient: 'Building',
};

export const INTENSITY_LABELS = {
  low_heavy: 'Light on Heavy sets',
  balanced: 'Balanced',
  high_heavy: 'Lots of Heavy sets',
  insufficient: 'Building',
};

// Away/break weeks are shaded bands, always paired with a text label.
export const GAP_LABELS = { away: 'Away', break: 'Break' };
export const GAP_COLORS = {
  away: 'rgba(76,201,240,0.22)',
  break: 'rgba(154,164,178,0.25)',
};
export const AWAY_LABEL_MAX = 40;
export const AWAY_MAX_DAYS = 366;
// Gap bands narrower than this get no text label on a sparkline (shading and aria-label only).
export const BAND_LABEL_MIN_WEEKS = 3;

// Member targets: limits mirror the backend contract.
export const SETS_MIN = 2;
export const SETS_MAX = 10;
export const PUSH_PULL_MIN_RANGE = { min: 0.5, max: 1.0 };
export const PUSH_PULL_MAX_RANGE = { min: 1.0, max: 2.0 };
export const PUSH_PULL_GAP = 0.1;
export const LOWER_BODY_RANGE = { min: 10, max: 60 };

export const TARGET_LIFTS = [
  { key: 'ChestPress', label: 'Chest press' },
  { key: 'LatPulldown', label: 'Lat pulldown' },
  { key: 'StandingCableRow', label: 'Standing cable row' },
  { key: 'OverheadPress', label: 'Overhead press' },
  { key: 'CableSquat', label: 'Cable squat' },
  { key: 'StiffLegDeadlift', label: 'Stiff-leg deadlift' },
];

export const DEFAULT_TARGETS = {
  setsPerLift: {
    ChestPress: 4,
    LatPulldown: 5,
    StandingCableRow: 4,
    OverheadPress: 4,
    CableSquat: 4,
    StiffLegDeadlift: 4,
  },
  pushPullMin: 0.9,
  pushPullMax: 1.1,
  lowerBodyMinPct: 30,
};

export const TARGET_STATUS_LABELS = {
  below: 'Below target',
  in: 'On target',
  above: 'Above target',
  insufficient: 'Not enough data yet',
};
export const TARGET_STATUS_TONES = {
  below: 'caution',
  in: 'good',
  above: 'neutral',
  insufficient: 'neutral',
};
